var productionConfig = {
    aadUrl: 'https://login.microsoftonline.com/',
    agreementApi: 'https://main.prod.marketplaceagreement.azure.com',
    agreementAppId: '5b93104f-32d5-4dcc-a480-72f0a10b1afa',
    appsourceUrl: 'https://appsource.microsoft.com',
    azureManagementApi: 'https://management.azure.com',
    commerceAppId: '982bda36-4632-4165-a46a-9863b1bbcf7d',
    graphApi: 'https://graph.microsoft.com',
    i18nResources: 'https://static.cloudmarketplace.microsoft.com/',
    jarvisApi: 'https://jarvisapi.account.microsoft.com',
    marketplaceLeadsAppId: '3a18646b-b6f4-4f1c-950d-4ac6da7424ef',
    marketplaceLeadsUrl: 'https://main.prod.marketplaceleads.azure.com',
    partnersApi: 'https://main.prod.marketplacepartnerdirectory.azure.com/api',
    pifdApi: 'https://paymentinstruments.mp.microsoft.com',
    searchApi: 'https://catalogapi.azure.com',
    telemetryEnv: 'PROD'
};

export { productionConfig };
